import debounce from "lodash/debounce";

export function scrollElemTop(element, offset = 0) {
    if (element) {
        const elementRect = element.getBoundingClientRect();
        const offsetTop = elementRect.top + window.scrollY - offset;

        const debouncedScroll = debounce(() => {
            window.scrollTo(0, offsetTop);
        }, 500);

        debouncedScroll();
    }
}
